import type { UserRole } from '@/lib/constants/roles';
import { type WidgetId } from '../config';
import { useDashboardLayout } from '../use-dashboard-layout';
import { WidgetGrid } from './WidgetGrid';

interface Props {
  role: UserRole;
  editing: boolean;
}

/**
 * Persistent KPI strip above the tabs. Uses the same sortable +
 * resizable grid as every tab; its layout is stored under the `kpi`
 * scope so KPIs and tab widgets persist independently.
 */
export function KpiStrip({ role, editing }: Props) {
  const { layout, reorder, setSize, remove } = useDashboardLayout('kpi');
  if (layout.length === 0) return null;
  return (
    <WidgetGrid
      layout={layout}
      editing={editing}
      onReorder={reorder}
      onResize={(id: WidgetId, size) => setSize(id, size)}
      onRemove={remove}
      role={role}
    />
  );
}
